import React from 'react';
import Footer from "../components/Footer";
import Header from "../components/Header";
import '../styles/Service.css';

const Service = () => {
  return (
    <div>
      <Header/>
    
    <div className="services-container">
      
      <section className="intro">
        <h1>Our Services</h1>
        <p>
          At <strong>CyberKon</strong>, we are dedicated to developing digital tools that simplify and improve the
          construction process. Our current focus is on accurate, easy-to-use estimation tools, with more features in the pipeline.
        </p>
      </section>

      <section className="services-list">
        <div className="service-item">
          <h2>Concrete Estimation</h2>
          <p>Estimate volumes for slabs, columns, beams, and foundations with precision and ease.</p>
        </div>

        <div className="service-item">
          <h2>Steel Estimation</h2>
          <p>Calculate required steel quantities for reinforced concrete elements quickly.</p>
        </div>

        <div className="service-item">
          <h2>Block & Mortar Estimation</h2>
          <p>Plan wall construction with block and mortar mix estimators tailored to your design.</p>
        </div>

        <div className="service-item">
          <h2>Formwork Estimation</h2>
          <p>Estimate formwork areas for vertical and horizontal concrete elements.</p>
        </div>

        <div className="service-item coming-soon">
          <h2>Roof Estimation <span>(Coming Soon)</span></h2>
          <p>Our upcoming roof estimator will support pitch, span, and sheet area calculations.</p>
        </div>

        <div className="service-item future-plan">
          <h2>Future Tools</h2>
          <p>CyberKon aims to develop tools for project scheduling, BOQ generation, procurement planning, and more.</p>
        </div>
      </section>
     
    </div>
     <Footer/>
    </div>
  );
};

export default Service;
